module.exports = __webpack_public_path__ + "media/images/project/reward/r50000-fcc2a46ea4da5994f98dda733437823b.jpg";